import React from 'react';
import { motion } from 'framer-motion';

const startups = [
  { id: 1, name: 'TechFlow AI', industry: 'AI/ML', logo: 'TF', color: 'bg-blue-500' },
  { id: 2, name: 'FinPay', industry: 'Fintech', logo: 'FP', color: 'bg-green-500' },
  { id: 3, name: 'HealthTech Inc', industry: 'Healthcare', logo: 'HT', color: 'bg-red-500' },
  { id: 4, name: 'DataSync', industry: 'SaaS', logo: 'DS', color: 'bg-purple-500' },
  { id: 5, name: 'CloudNest', industry: 'Cloud', logo: 'CN', color: 'bg-cyan-500' },
  { id: 6, name: 'PayFlow', industry: 'Payments', logo: 'PF', color: 'bg-indigo-500' },
  { id: 7, name: 'MediCare+', industry: 'Healthtech', logo: 'MC', color: 'bg-pink-500' },
  { id: 8, name: 'CodeStack', industry: 'DevTools', logo: 'CS', color: 'bg-orange-500' },
  { id: 9, name: 'ShopEase', industry: 'E-commerce', logo: 'SE', color: 'bg-teal-500' },
  { id: 10, name: 'EduLearn', industry: 'EdTech', logo: 'EL', color: 'bg-amber-500' },
];

export const CoveredStartups = () => {
  // Duplicate the array for seamless infinite scroll
  const duplicatedStartups = [...startups, ...startups];

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-background to-muted/30 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-heading mb-2">
            Covered Startups
          </h2>
          <p className="text-muted-foreground">
            Join 100+ startups sharing their stories with the world
          </p>
        </div>

        {/* Scrolling Carousel */}
        <div className="relative">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10" />

          {/* Scrolling Container */}
          <div className="flex overflow-hidden">
            <motion.div
              className="flex gap-8 sm:gap-12"
              animate={{
                x: [0, -50 * startups.length],
              }}
              transition={{
                x: {
                  repeat: Infinity,
                  repeatType: "loop",
                  duration: 30,
                  ease: "linear",
                },
              }}
            >
              {duplicatedStartups.map((startup, index) => (
                <div
                  key={`${startup.id}-${index}`}
                  className="flex-shrink-0 group"
                >
                  <div className="w-40 h-28 sm:w-48 sm:h-32 bg-card rounded-xl border border-border flex flex-col items-center justify-center p-4 gap-3 transition-all duration-300 hover:shadow-card-hover hover:border-primary/30 hover:scale-105 cursor-pointer">
                    {/* Logo */}
                    <div className={`w-12 h-12 sm:w-14 sm:h-14 ${startup.color} rounded-lg flex items-center justify-center text-white font-bold text-lg sm:text-xl shadow-md group-hover:scale-110 transition-transform`}>
                      {startup.logo}
                    </div>
                    {/* Company Name */}
                    <div className="text-center">
                      <h3 className="font-heading font-semibold text-sm sm:text-base text-foreground group-hover:text-primary transition-colors">
                        {startup.name}
                      </h3>
                      <p className="text-xs text-muted-foreground mt-0.5">
                        {startup.industry}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
